import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ResuLiquidacionService } from 'app/services/resu_liquidacion.service';
import { PersonalService } from '../../../../services/personal.service';
import { ConfigDataService } from 'app/services/config-data.service';
import { ModeloConstanciaService } from 'app/services/modelo-constancia.service';
import { SubSedeService } from '../../../../services/subSede.service';
import { saveAs } from "file-saver";

@Component({
  selector: 'app-reporte-constancia-filt',
  templateUrl: './reporte-constancia-filt.component.html',
  styleUrls: ['./reporte-constancia-filt.component.css']
})
export class ReporteConstanciaFiltComponent implements OnInit  {

  MensajeError: string;
  legajo: number = 0;
  recibosList: any;
  showDetails:boolean = false;
  rowsExport: any;
  sociedadesList: any;
  sedesList: any;
  subsedesList: any;
  modelosList: any;
  personalList: any;
  selectedLegajo: string;
  Invalido: boolean;
  pdfSource:string;
  zoom: number = 0;
  tamanio: number = 50;

  public constructor(private formuBuilder: FormBuilder,
                      private service: ResuLiquidacionService,
                      private actRoute: ActivatedRoute,
                      private modelosService: ModeloConstanciaService,
                      private configDataSrv: ConfigDataService,
                      private personalService: PersonalService,
                      private subSedeSrv: SubSedeService
                      ) {
  }
  
  public ngOnInit():any {
    this.cambiarZoom();
    
    this.modelosService.getAll().subscribe(data =>{this.modelosList = data});
    this.personalService.getAll().subscribe(data =>{this.personalList = data});
    this.configDataSrv.GetCombosInfoDatosOrganizativos().subscribe(
      data => {
        this.sociedadesList=data["Sociedades"];
        this.sedesList=data["Sedes"];
      }
    );

  }

  onSubmit(){}
  
  registerForm = this.formuBuilder.group({
    sociedad: [''],
    sede: [''],
    subSede: [''],
    modelo: [''],
    fecha: [new Date(), Validators.required],
    firma: ['']
  });

  verResultados(): void 
  {
    this.MensajeError = "";
    this.Invalido = false;
    this.showDetails = false;
    let filtros = this.registerForm.value;
    
    if (filtros.modelo == null || filtros.modelo == '')
    {
      this.MensajeError = "Debe seleccionar Modelo";
      this.Invalido = true;
    } else 
    {
      this.showDetails = true;
      this.modelosService.Imprimir(filtros.modelo, this.legajo, Number(filtros.sociedad), Number(filtros.sede), Number(filtros.subSede), filtros.fecha.toDateString(), filtros.firma).subscribe(
        data => {
        let file = new Blob([data], {type: 'application/pdf'});
        this.pdfSource = URL.createObjectURL(file);
      },
      err => {
        alert("Hubo un problema al generar el PDF");
        console.error(err);
      });
    }
  }

  imprimir() {
    let filtros = this.registerForm.value;
    this.modelosService.Imprimir(filtros.modelo, this.legajo, Number(filtros.sociedad), Number(filtros.sede), Number(filtros.subSede), filtros.fecha.toDateString(), filtros.firma).subscribe(
      data => {
        saveAs(data, 'Constancia_legajo_' + this.legajo );
      },
      err => {
        alert("Hubo un problema al descargar la constancia");
        console.error(err);
      } 
    );
  }
  
  onChangeLegajo(event) {
    this.legajo = 0
    if (event.value){
        this.legajo = Number(event.value.code)
    }
  }
  onChangeSede(event) {
    this.registerForm.controls['subSede'].setValue(null);
    this.cargarSubSedes(event.value);    
  }

  cargarSubSedes(sede:number){
    if (sede != null) {
      this.subSedeSrv.getSubSedes(sede).subscribe(data => { this.subsedesList = data })
    }
  }

  cambiarZoom()
  {
    this.zoom = this.tamanio / 100;
  }
}
    